import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import getGdprBannerTemplate from '../templates/getGdprBannerTemplate';
import getGdprBannerTemplateBNL13199B from '../templates/getGdprBannerTemplateBNL13199B';
import getBannerStyles from '../styles/getBannerStyles';
import appendToDocumentBody from './appendToDocumentBody';
import lockBodyScroll from './lockBodyScroll';
import isExperimentEnabled from './isExperimentEnabled';

/**
 * This function gets the css and html markup and then
 * appends it to document.body
 */
const renderBanner = () => {
  let gdprBannerTemplateHtml = getGdprBannerTemplate;
  if (GDPRConfig.locale === 'nl-NL' && isExperimentEnabled('BNL13199', 'B')) {
    gdprBannerTemplateHtml = getGdprBannerTemplateBNL13199B;
  }
  lockBodyScroll(true);
  appendToDocumentBody(getBannerStyles(), gdprBannerTemplateHtml());
};

export default renderBanner;
